var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ah-file-icon",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/img/file-icon.svg")}}),_c('div',{staticClass:"ext"},[_vm._v(_vm._s(_vm.extText))])])}
var staticRenderFns = []

export { render, staticRenderFns }